import { ExpressionSpecification } from "@iventis/mapbox-gl";
import { StyleValue } from "@iventis/domain-model/model/styleValue";
import { DataField } from "@iventis/domain-model/model/dataField";
import { SystemDataFieldName } from "@iventis/domain-model/model/systemDataFieldName";
import { StyleType } from "@iventis/domain-model/model/styleType";
import { getStaticStyleValue } from "@iventis/layer-style-helpers";
import { styleValueToMapboxStyleValue } from "./engine-mapbox-helpers";
import { getDefaultStyleProperty } from "../../utilities/style-helpers";

/**
 * Converts the icon rotation style values to a mapbox style value
 * Combines the layer style value with the IconRotation system data field
 * @param styleValue The icon rotation style value to combine with the system data field
 * @param projectDataFields The project data fields which contain icon rotation datafield
 */
export function iconRotationValueToMapboxStyleValue<T>(styleValue?: StyleValue<T>, projectDataFields?: DataField[]) {
    if (!styleValue) {
        // If no style value, return the default style value. This is expected in some cases
        return getStaticStyleValue(getDefaultStyleProperty(StyleType.Icon, "rotation"));
    }

    const iconRotationDataField = projectDataFields?.find((df) => df.systemDataFieldName === SystemDataFieldName.IconRotation);
    if (!iconRotationDataField) {
        // If no datafield, return the base style value as a fallback
        // eslint-disable-next-line no-console
        console.warn("No icon rotation data field found in project data fields");
        return styleValueToMapboxStyleValue(styleValue);
    }

    // Get the base rotation from the style value and the system rotation
    const baseRotation = styleValueToMapboxStyleValue(styleValue);

    // Use coalesce to default to 0 if the data field value is null
    const systemRotation: ExpressionSpecification = ["coalesce", ["get", iconRotationDataField.id], 0];

    // Add in expression
    const combinedExpression: ExpressionSpecification = ["+", baseRotation, systemRotation];

    return combinedExpression;
}
